import React from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import { ColorOptions } from '../droppableHeaderV2.models';
import { Button } from 'antd';
import ChevronUpGlyph from '../../../../assets/icons/Glyph/ChevronUpGlyph';

export function DroppableHeaderActionsCollapseAllButton() {
  const { color, glyphColor } = useDroppableHeaderContext();
  const validColors: ColorOptions[] = ['GREY', 'BLUE'];

  if (!validColors.includes(color)) return null;

  return (
    <Button
      type='default'
      size='small'
      className={`button-with-icon ${
        {
          GREY: 'btn-gray-primary',
          BLUE: 'btn-gray-secondary'
        }[color]
      }`}>
      <span className='mr-15'>Collapse all</span>
      <span className='icon-container'>
        <ChevronUpGlyph color={glyphColor} />
      </span>
    </Button>
  );
}
